import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { IoIosDocument } from 'react-icons/io'
import { get, isUndefined } from 'lodash'
import { formatUtcDateTime } from '../../lib/dateFormatters'
import Treeable from '../common/Treeable'
import Component from '../common/Component'
import withRouter from '../../lib/withRouter'
import howieGeographyActions from '../../actions/HowieGeographies'

export class HowieGeographiesShow extends Component {
  static propTypes = {
    showHowieGeographyAction: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    howieGeography: PropTypes.object,
    params: PropTypes.object.isRequired
  }

  componentDidMount() {
    const { showHowieGeographyAction } = this.props
    showHowieGeographyAction(this.id)
  }

  get defaultAttributes() {
    return { howie_geography_id: this.id, rejection_reason: '' }
  }

  get id() {
    return this.props.params.id
  }

  get shouldRender() {
    return this.props.howieGeography
  }

  get hasAttachedDocument() {
    return isUndefined(this.props.howieGeography.document)
  }

  get documentUrl() {
    return this.props.howieGeography.document.public_url
  }

  get documentLink() {
    if (this.hasAttachedDocument) {
      return (
        <a href={this.documentUrl} target="_sbc">
          <IoIosDocument size={30} />
          Document
        </a>
      )
    }
    return 'No Document Attached'
  }

  get treeComponents() {
    return (
      this.props.howieGeography.zip_counties.map((tree, index) => (
        <Treeable
          key={`${tree.name}_${index}`}
          name={tree.name}
          data={tree}
        />
      ))
    )
  }

  get returnPath() {
    return get(this.props.location, '/howie_geographies', '/howie_geographies/')
  }

  formattedDateValue = (value) => {
    return formatUtcDateTime(value)
  }

  render() {
    const { howieGeography } = this.props

    if (!this.shouldRender) return null

    return (
      <div className="content">
        <h1>Howie Geography</h1>
        <div>
          {this.documentLink}
        </div>
        <h5>Metadata</h5>
        <table className="pure-table">
          <tbody>
            <tr>
              <td><strong>Name</strong></td>
              <td name="name">{howieGeography.name}</td>
            </tr>
            <tr>
              <td><strong>Last Updated At</strong></td>
              <td name="updated_at">{this.formattedDateValue(howieGeography.updated_at)}</td>
            </tr>
            <tr>
              <td><strong>Number of Zip Codes</strong></td>
              <td name="name">{howieGeography.zip_code_count}</td>
            </tr>
          </tbody>
        </table>
        <br />
        <h5>Zip Codes</h5>
        <div className="tree">
          {this.treeComponents}
        </div>
        <br />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const showSlice = state.howieGeographies.show
  const configuration = state.login.session.configuration.howie_geographies

  return {
    howieGeography: showSlice.attributes,
    configuration
  }
}

const mapDispatchToProps = {
  showHowieGeographyAction: howieGeographyActions.show.main
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(HowieGeographiesShow))
